import { observable, makeObservable, action } from 'mobx';
import { api } from '../../constants/apis';
import { deleteRequest, get, post } from '../../utils/axios-requests';
//import filterContacts from '../contacts/contacts.utils';

export default class FindPeopleUiStore {
  @observable error: string = '';
  @observable context: any = null;
  @observable loading: boolean = false;
  @observable userCards: Array<any> = [];

  constructor() {
    makeObservable(this);
  }

  @action
  public initliazeContext = (context: any) => {
    this.context = context;
  };

  @action
  public setError = (err: string) => {
    this.error = err;
  };

  @action
  public fetchCards = async () => {
    try {
      const res = await get(api.cards.user, {
        userId: this.context.authenticatedUser.id,
      });
      this.userCards = res.data;
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };

  @action
  public search = async (query: string, filters: any) => {
    try {
      const res = await post(api.search.all, {
        query,
        filters
      });

      return res.data;
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };

  // @action
  // public filterContacts = async (query: string) => {
  //   if (query) {
  //     const data = await filterContacts(query, this.allContacts);
  //     runInAction(() => {
  //       this.contacts = data;
  //     });
  //   } else {
  //     this.contacts = this.allContacts;
  //   }
  // };

  @action
  public getAllTags = async () => {
    try {
      const res = await get(api.tags.all);

      return res.data;
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };


  @action
  public getContactsFilters = async () => {
    try {
      const res = await get(api.connections.filters);

      return res.data;
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }
      return false;
    }
  };

  @action
  public fetchInfoSuggestions = async (
    infoType: string,
    countryId: any = null,
    stateId: any = null
  ) => {
    try {
      const res = await get(api.informationList.single, {
        infoType,
        countryId,
        stateId,
      });

      return res.data;
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };

  @action
  public updateFollow = async (follow: boolean, cardId: string) => {
    try {
      if (follow)
        await post(api.connections.follow, {
          cardRequested: cardId,
        });
      else
        await deleteRequest(api.connections.unfollow, {
          cardId,
        });
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };


  @action
  public sendSyncRequest = async (
    cards: Array<string>,
    message: string,
    cardId: string
  ) => {
    try {
      const res = await post(api.connections.requests, {
        cardRequested: cardId,
        cards,
        message,
      });

      return res.data;
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };
}
